export default __webpack_public_path__ + "static/audit-bee-3fcc474ad9a77a1dc2ceea99723d49ff.png";